@if (show()) {
  @let days = daysRemaining();
  <skk-banner type="warning" [customIcon]="CreditCardIcon">
    <div class="trial-banner">
      <span class="trial-banner__text">
        @if (days === 0) {
          <ng-container i18n="@@trialBanner.today"
            >Your free trial ends today. Add a payment method to keep access to
            Sklepnik.</ng-container
          >
        } @else if (days !== null) {
          <ng-container i18n="@@trialBanner.message"
            >Your free trial ends in {{ days }} {days, plural, =1 {day} other {days}}. Add a payment
            method to keep access to Sklepnik.</ng-container
          >
        } @else {
          <ng-container i18n="@@trialBanner.generic"
            >Your free trial is ending. Add a payment method to keep access to
            Sklepnik.</ng-container
          >
        }
      </span>
      <button
        type="button"
        class="btn btn--primary btn--sm trial-banner__cta"
        [disabled]="isLoading()"
        (click)="addPaymentMethod()"
        i18n="@@trialBanner.cta"
      >
        Add payment method
      </button>
    </div>
  </skk-banner>
}
